import React, { useState } from 'react';

import { AnimatePresence } from 'framer-motion';
import { useTranslation } from 'react-i18next';

import { Sheet, type SheetHeaderProps } from '@pkg/components';
import { useMediaQuery } from '@pkg/providers';

import { NftCollection, type NftCollectionProps, SearchResults, type SearchResultsProps } from './sections';

export interface GroupImagePickerProps {
    podName?: NftCollectionProps['podName'];
    nftCount?: NftCollectionProps['nftCount'];
    onClose(): void;
}

export function GroupImagePicker({ podName, nftCount, onClose }: GroupImagePickerProps) {
    const [translate] = useTranslation('yat_nft_manager');
    const { tablet } = useMediaQuery();

    const [searchValue, setSearchValue] = useState<SearchResultsProps['value']>('');

    const handleSearchInput: SheetHeaderProps['onSearchInput'] = ({ target }) => {
        setSearchValue(target.value);
    };

    const handleSearchClear: SheetHeaderProps['onSearchClear'] = () => {
        setSearchValue('');
    };

    const mainContent = searchValue ? (
        <SearchResults value={searchValue} />
    ) : (
        <NftCollection podName={podName} nftCount={nftCount} />
    );

    return (
        <Sheet backdrop size="wide" onClose={onClose}>
            <Sheet.Header
                showSearch
                searchValue={searchValue}
                searchPlaceholder={
                    tablet
                        ? translate('yat_nft_manager_search_placeholder_desktop')
                        : translate('yat_nft_manager_search_placeholder_mobile')
                }
                onSearchInput={handleSearchInput}
                onSearchClear={handleSearchClear}
                onClose={onClose}
            />

            <AnimatePresence mode="wait">
                <Sheet.Main key={`SheetViews-${Boolean(searchValue)}`}>{mainContent}</Sheet.Main>
            </AnimatePresence>
        </Sheet>
    );
}
